var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C8 2.44772 8.44772 2 9 2H11C11.5523 2 12 2.44772 12 3V4H15.3819C15.7607 4 16.107 4.214 16.2764 4.55279L16.6382 5.27639C16.8044 5.60884 16.5627 6 16.191 6H3.80899C3.4373 6 3.19556 5.60884 3.36178 5.27639L3.72358 4.55279C3.89298 4.214 4.23924 4 4.61801 4H8V3ZM5.09916 8.09054C5.04592 7.50492 5.50702 7 6.09505 7H13.905C14.493 7 14.9541 7.50492 14.9009 8.09054L14.1654 16.1811C14.0717 17.2112 13.208 18 12.1736 18H7.82645C6.79204 18 5.92831 17.2112 5.83466 16.1811L5.09916 8.09054ZM7.92442 8.66843C8.38369 8.62668 8.78984 8.96514 8.83159 9.4244L9.33159 14.9244C9.37334 15.3837 9.03488 15.7898 8.57562 15.8316C8.11635 15.8733 7.7102 15.5349 7.66845 15.0756L7.16845 9.5756C7.1267 9.11633 7.46516 8.71018 7.92442 8.66843ZM12.8316 9.5756C12.8733 9.11633 12.5349 8.71018 12.0756 8.66843C11.6164 8.62668 11.2102 8.96514 11.1684 9.4244L10.6684 14.9244C10.6267 15.3837 10.9652 15.7899 11.4244 15.8316C11.8837 15.8734 12.2898 15.5349 12.3316 15.0756L12.8316 9.5756Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2e1ba795b20af0cabbfbceb1e2280063.svg";
export { ForwardRef as ReactComponent };